/* Shop4Seats — product info tabs (desktop) / accordions (mobile). One DOM:
 * desktop shows the .is-active panel (tablist with arrow keys); mobile toggles .is-open per panel. */
(() => {
  if (customElements.get('s4s-info-tabs')) return;
  class InfoTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-itab]')];
      this.panels = [...this.querySelectorAll('[data-ipanel]')];
      this.addEventListener('click', (e) => {
        const tab = e.target.closest('[data-itab]');
        if (tab) return this.select(tab.dataset.itab);
        const acc = e.target.closest('[data-iacc]');
        if (acc) {
          const panel = acc.closest('[data-ipanel]');
          const open = !panel.classList.contains('is-open');
          panel.classList.toggle('is-open', open);
          acc.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      });
      this.addEventListener('keydown', (e) => {
        const tab = e.target.closest('[data-itab]');
        if (!tab || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
        const i = this.tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
        const next = this.tabs[(i + this.tabs.length) % this.tabs.length];
        next.focus();
        this.select(next.dataset.itab);
      });
    }
    select(id) {
      this.tabs.forEach((t) => t.setAttribute('aria-selected', t.dataset.itab === id ? 'true' : 'false'));
      this.panels.forEach((p) => p.classList.toggle('is-active', p.dataset.ipanel === id));
    }
  }
  customElements.define('s4s-info-tabs', InfoTabs);
})();
